exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-f3e5ccaa]{color:#fff;font-family:Roboto,sans-serif}.header[data-v-f3e5ccaa]{height:50px;display:flex;align-items:center;justify-content:center}.signUpContainer[data-v-f3e5ccaa]{display:flex;flex-flow:column;align-items:center;justify-content:center;height:300px;font-family:Roboto,sans-serif}.signUpContainer input[type=text][data-v-f3e5ccaa],input[type=password][data-v-f3e5ccaa]{background:#fff;color:#000;padding:10px;border-radius:5px;outline:none;margin-top:20px}.promo[data-v-f3e5ccaa]{color:#fff;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3e5ccaa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/_mainDirectives/entryComponents/loginForm.vue
// module id = 449
// module chunks = 0